import EditMessageDialog from "./EditMessageModal";

export default EditMessageDialog;
